import { Map } from "../../helper/routeMap";

/** Network */
import HelpCenter from "./helpCenter";
import {
  DomainModule,
  ContentAddModule,
  ContentManageModule,
  PlaylistModule,
  CampaignContentModule,
  CampaignManageModule,
  CalendarModule,
  NetworkModule,
  FAQModule,
  CommonRequestsModule
} from "./modules/helpCenterModule";

const mainPath = "/help";
const pathCreator = `${mainPath}`;
const subPathCreator = subPath => `${pathCreator}/${subPath}`;
const feature = "Help";

export default [
  {
    path: `${pathCreator}`,
    component: Map(HelpCenter),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("domains")}`,
    component: Map(DomainModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("contents/addNewAssets")}`,
    component: Map(ContentAddModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("contents/manageContents")}`,
    component: Map(ContentManageModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("playlists")}`,
    component: Map(PlaylistModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("campaigns/campaignsAndContent")}`,
    component: Map(CampaignContentModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("campaigns/manageCampaign")}`,
    component: Map(CampaignManageModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("calendars")}`,
    component: Map(CalendarModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("networks")}`,
    component: Map(NetworkModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("FAQ")}`,
    component: Map(FAQModule),
    exact: true,
    secured: true,
    feature
  },
  {
    path: `${subPathCreator("Common Request")}`,
    component: Map(CommonRequestsModule),
    exact: true,
    secured: true,
    feature
  }
];
